import Tone from 'tone';
import Effects from 'effects/Effects.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';
import {AudioParamPercentageValueParameter, AudioParamValueParameter} from 'parameters/AbstractAudioParamParameter.js';

const TYPE = 'peaking';

class EQ10 extends Effects.Effect {
    constructor(sequencerEngine) {
        super('EQ 10', () => new Tone.Gain(1), sequencerEngine);

        // todo: make 31 hz a shelf?
        this.filter31 = new Tone.Filter(31, TYPE);
        this.filter31.Q.value = 0.71;
        this.filter63 = new Tone.Filter(63, TYPE);
        this.filter63.Q.value = 0.71;
        this.filter125 = new Tone.Filter(125, TYPE);
        this.filter125.Q.value = 0.71;
        this.filter250 = new Tone.Filter(250, TYPE);
        this.filter250.Q.value = 0.71;
        this.filter500 = new Tone.Filter(500, TYPE);
        this.filter500.Q.value = 0.71;
        this.filter1k = new Tone.Filter(1000, TYPE);
        this.filter1k.Q.value = 0.71;
        this.filter2k = new Tone.Filter(2000, TYPE);
        this.filter2k.Q.value = 0.71;
        this.filter4k = new Tone.Filter(4000, TYPE);
        this.filter4k.Q.value = 0.71;
        this.filter8k = new Tone.Filter(8000, TYPE);
        this.filter8k.Q.value = 0.71;

        // todo: make a shelf
        this.filter16k = new Tone.Filter(16000,TYPE);
        this.filter16k.Q.value = 0.71;
        this.outputNode = new Tone.Gain(1);

        this.effectNode.chain(
            this.filter31,
            this.filter63,
            this.filter125,
            this.filter250,
            this.filter500,
            this.filter1k,
            this.filter2k,
            this.filter4k,
            this.filter8k,
            this.filter16k,
            this.outputNode);

        this.gain31Parameter = new AudioParamValueParameter(
            'Gain 31', this.filter31.gain, {
                min: -12,
                max: 12,
                unit: 'db',
                defaultValue: 0
            });
        this.registerParameter(this.gain31Parameter);

        this.gain63Parameter = new AudioParamValueParameter(
            'Gain 63', this.filter63.gain, {
                min: -12,
                max: 12,
                unit: 'db',
                defaultValue: 0
            });
        this.registerParameter(this.gain63Parameter);

        this.gain125Parameter = new AudioParamValueParameter(
            'Gain 125', this.filter125.gain, {
                min: -12,
                max: 12,
                unit: 'db',
                defaultValue: 0
            });
        this.registerParameter(this.gain125Parameter);

        this.gain125Parameter = new AudioParamValueParameter(
            'Gain 125', this.filter125.gain, {
                min: -12,
                max: 12,
                unit: 'db',
                defaultValue: 0
            });
        this.registerParameter(this.gain125Parameter);

        this.gain250Parameter = new AudioParamValueParameter(
            'Gain 250', this.filter250.gain, {
                min: -12,
                max: 12,
                unit: 'db',
                defaultValue: 0
            });
        this.registerParameter(this.gain250Parameter);

        this.gain500Parameter = new AudioParamValueParameter(
            'Gain 500', this.filter500.gain, {
                min: -12,
                max: 12,
                unit: 'db',
                defaultValue: 0
            });
        this.registerParameter(this.gain500Parameter);

        this.gain1kParameter = new AudioParamValueParameter(
            'Gain 1k', this.filter1k.gain, {
                min: -12,
                max: 12,
                unit: 'db',
                defaultValue: 0
            });
        this.registerParameter(this.gain1kParameter);
        
        this.gain2kParameter = new AudioParamValueParameter(
            'Gain 2k', this.filter2k.gain, {
                min: -12,
                max: 12,
                unit: 'db',
                defaultValue: 0
            });
        this.registerParameter(this.gain2kParameter);

        this.gain4kParameter = new AudioParamValueParameter(
            'Gain 4k', this.filter4k.gain, {
                min: -12,
                max: 12,
                unit: 'db',
                defaultValue: 0
            });
        this.registerParameter(this.gain4kParameter);

        this.gain8kParameter = new AudioParamValueParameter(
            'Gain 8k', this.filter8k.gain, {
                min: -12,
                max: 12,
                unit: 'db',
                defaultValue: 0
            });
        this.registerParameter(this.gain8kParameter);

        this.gain16kParameter = new AudioParamValueParameter(
            'Gain 16k', this.filter16k.gain, {
                min: -12,
                max: 12,
                unit: 'db',
                defaultValue: 0
            });
        this.registerParameter(this.gain16kParameter);
    }

    connect(node) {
        this.outputNode.connect(node);
    }

    disconnect() {
        this.outputNode.disconnect();
    }

    getJson() {
        let json = {
            ... super.getJson(),
            gain63: this.gain63Parameter.get(),
            gain125: this.gain125Parameter.get(),
            gain250: this.gain250Parameter.get(),
            gain500: this.gain500Parameter.get(),
            gain1k: this.gain1kParameter.get(),
            gain2k: this.gain2kParameter.get(),
            gain4k: this.gain4kParameter.get(),
            gain8k: this.gain8kParameter.get(),
            gain16k: this.gain16kParameter.get(),
        };

        json = this.saveParameterToJson(json, 'gain31Parameter', this.gain31Parameter);
        json = this.saveParameterToJson(json, 'gain63Parameter', this.gain63Parameter);
        json = this.saveParameterToJson(json, 'gain125Parameter', this.gain125Parameter);
        json = this.saveParameterToJson(json, 'gain250Parameter', this.gain250Parameter);
        json = this.saveParameterToJson(json, 'gain500Parameter', this.gain500Parameter);
        json = this.saveParameterToJson(json, 'gain1kParameter', this.gain1kParameter);
        json = this.saveParameterToJson(json, 'gain2kParameter', this.gain2kParameter);
        json = this.saveParameterToJson(json, 'gain4kParameter', this.gain4kParameter);
        json = this.saveParameterToJson(json, 'gain8kParameter', this.gain8kParameter);
        json = this.saveParameterToJson(json, 'gain16kParameter', this.gain16kParameter);
        return json;
    }

    fromJson(json, isCopy) {
        super.fromJson(json, isCopy);

        this.gain63Parameter.set(json.gain63);
        this.gain125Parameter.set(json.gain125);
        this.gain250Parameter.set(json.gain250);
        this.gain500Parameter.set(json.gain500);
        this.gain1kParameter.set(json.gain1k);
        this.gain2kParameter.set(json.gain2k);
        this.gain4kParameter.set(json.gain4k);
        this.gain8kParameter.set(json.gain8k);
        this.gain16kParameter.set(json.gain16k);

        this.loadParameterFromJson(json, 'gain31Parameter', this.gain31Parameter, isCopy);
        this.loadParameterFromJson(json, 'gain63Parameter', this.gain63Parameter, isCopy);
        this.loadParameterFromJson(json, 'gain125Parameter', this.gain125Parameter, isCopy);
        this.loadParameterFromJson(json, 'gain250Parameter', this.gain250Parameter, isCopy);
        this.loadParameterFromJson(json, 'gain500Parameter', this.gain500Parameter, isCopy);
        this.loadParameterFromJson(json, 'gain1kParameter', this.gain1kParameter, isCopy);
        this.loadParameterFromJson(json, 'gain2kParameter', this.gain2kParameter, isCopy);
        this.loadParameterFromJson(json, 'gain4kParameter', this.gain4kParameter, isCopy);
        this.loadParameterFromJson(json, 'gain8kParameter', this.gain8kParameter, isCopy);
        this.loadParameterFromJson(json, 'gain16kParameter', this.gain16kParameter, isCopy);
        this.enable(json.enabled);
    }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        var copy = new EQ10(sequencerEngine);
        copy.fromJson(this.getJson(), ignoreId);
        return copy;
    }
}

export default EQ10;
